import { createRootRoute, Outlet, CatchBoundary } from '@tanstack/react-router'
import { ErrorBoundary } from '../components/ErrorBoundary'

export const Route = createRootRoute({
  component: () => (
    <>
      <CatchBoundary
        getResetKey={() => window.location.href}
        errorComponent={ErrorBoundary}
        onCatch={(error) => {
          console.error('Global error caught:', error)
        }}
      >
        <Outlet />
      </CatchBoundary>
      {/* <TanStackRouterDevtools /> */}
    </>
  ),
  meta: () => [{ title: 'Home' }],
})
